import { render, staticRenderFns } from "./NTitle.vue?vue&type=template&id=2732f436&"
import script from "./NTitle.vue?vue&type=script&lang=js&"
export * from "./NTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports